export interface GetProfileDetailsDto
{
    getUserName(): string;
    getProfilePicturePath(): string;
    getMsisdn(): string;
    getEmailId(): string;
    getCategories(): string[];
    getClientTxnId(): string;
    getRespDesc(): string;
    getDob(): string;
}

export class GetProfileDetailsDtoImpl implements GetProfileDetailsDto
{
    private userName: string;
    private profilePicturePath: string;
    private msisdn: string;
    private emailId: string;
    private categories: string[];
    private clientTxnId: string;
    private respDesc: string;
    private dob: string;

    setUserName(userName: string)
    {
        this.userName = userName;
    }
    getUserName(): string 
    {
        return this.userName;
    } 

    setProfilePicturePath(profilePicturePath: string)
    {
        this.profilePicturePath = profilePicturePath;
    }
    getProfilePicturePath(): string 
    {
        return this.profilePicturePath;
    } 

    setMsisdn(msisdn: string)
    {
        this.msisdn = msisdn;
    }
    getMsisdn(): string 
    {
        return this.msisdn;
    } 

    setEmailId(emailId: string)
    {
        this.emailId = emailId;
    }
    getEmailId(): string 
    {
        return this.emailId;
    } 

    setCategories(categories: string[])
    {
        this.categories = categories;
    }
    getCategories(): string[] 
    {
        return this.categories;
    } 

    setClientTxnId(clientTxnId: string)
    {
        this.clientTxnId = clientTxnId;
    }
    getClientTxnId(): string 
    {
        return this.clientTxnId;
    } 

    setRespDesc(respDesc: string)
    {
        this.respDesc = respDesc;
    }
    getRespDesc(): string 
    {
        return this.respDesc;
    } 

    setDob(dob: string)
    {
        this.dob = dob;
    }
    getDob(): string 
    {
        return this.dob;
    } 
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/getprofile/getprofiledetailsdto.ts